module.exports = __webpack_public_path__ + "img/icon_sale_white.32135eb0.svg";